import gql from 'graphql-tag';

export const GET_ENGAGEMENT = gql`
  query engagement($id: NexusId, $legacyId: NexusId, $type: String!, $isFirstPoll: Boolean, $userIsKnown: Boolean, $getNextEngagement: Boolean) {
    engagement(id: $id, legacyId: $legacyId, type: $type, isFirstPoll: $isFirstPoll, userIsKnown: $userIsKnown, getNextEngagement: $getNextEngagement) {
      answerDescription
      ctaLink
      ctaText
      id
      isCurrent
      isMultiSelect
      isSuggestable
      hasOptionCta
      options {
        displayOrder
        engagementId
        id
        isCorrect
        name
        totalVotes
        currentSiteTotalVotes
        ctaText
        ctaLink
      }
      question
      type
      userAnswers
      promoteOnForumIndexPage
      resultsRequireAuth
      resultsRequireKnown
    }
  }
`;
